import React from "react";

const SCDataList = ({ subClassInfo, mainImages, otherImages }) => {
  return (
    <div className="flex flex-col w-full items-center gap-2">
      <h2 className="font-bold text-xl w-[70%] text-wrap break-words text-center">
        Datos de la subclase
      </h2>
      <div className="flex flex-col w-full max-h-[400px] overflow-y-auto ">
        <ul className="gap-4 flex flex-col">
          <li>
            <b>Subclase:</b> {subClassInfo.name}
          </li>
          <li>
            <b>Id:</b> {subClassInfo.id}
          </li>
          {subClassInfo?.mainSpecs?.length > 0 && (
            <li>
              <b>Especificaciones principales existentes(filtros):</b>
              <div className="border-[1px] border-accent-green rounded-[10px] shadow-md w-full pt-2">
                {subClassInfo.mainSpecs.map((spec, i) => {
                  return (
                    <div
                      className={`flex flex-col gap-y-2 px-4 py-2 ${
                        i % 2 == 0 ? "bg-white" : "bg-light-green"
                      } ${
                        i == 0 && subClassInfo.mainSpecs.length == 1
                          ? "rounded-t-[10px] rounded-b-[10px]"
                          : i == 0
                          ? "rounded-t-[10px]"
                          : i == subClassInfo.mainSpecs.length - 1
                          ? "rounded-b-[10px]"
                          : ""
                      } w-full `}
                      key={i}
                    >
                      <div className="flex flex-row items-center gap-x-2 w-full">
                        <span className="font-poppins font-bold w-[50%] ">
                          {spec.name}
                        </span>
                        :
                        <div className="w-[50%] flex flex-wrap gap-x-2">
                          {spec.values.map((specValue, j) => {
                            return (
                              <div
                                className="flex flex-row items-center   "
                                key={j}
                              >
                                <span className="font-poppins  text-wrap break-words">
                                  {specValue.value}({specValue.code})
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </li>
          )}
          <li>
            <div className="border-[1px] rounded-md p-2 ">
              <h3 className="font-bold text-xl">Imágenes principales</h3>
              <div className="flex flex-wrap gap-2 ">
                {mainImages.map((img, i) => {
                  return (
                    <div
                      key={i}
                      className="flex flex-row w-full gap-1 bg-light-green p-2 rounded-md"
                    >
                      <img
                        src={process.env.REACT_APP_SERVER + img.url}
                        alt="otherImage"
                        className="w-[100px] h-[100px] rounded-md object-cover"
                      />
                      <span className="text-dark-green break-words w-full overflow-hidden">
                        <b>Id:</b> {img.id}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </li>
          <li>
            <div className="border-[1px] rounded-md p-2 ">
              <h3 className="font-bold text-xl">Imágenes secundarias</h3>
              <div className="flex flex-wrap gap-2 ">
                {otherImages.map((img, j) => {
                  return (
                    <div
                      key={j}
                      className="flex flex-row w-full gap-1 bg-light-green p-2 rounded-md"
                    >
                      <img
                        src={process.env.REACT_APP_SERVER + img.url}
                        alt="otherImage"
                        className="w-[100px] h-[100px] rounded-md object-cover"
                      />
                      <span className="text-dark-green break-words w-full overflow-hidden">
                        <b>Id:</b> {img.id}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SCDataList;
